export const GET_JOB_DETAILS_DATA = 'GET_JOB_DETAILS_DATA'
export const SET_JD_RESPONSE = 'SET_JD_RESPONSE'
